import { render, staticRenderFns } from "./CreateTypeModal.vue?vue&type=template&id=b244b5fa&scoped=true&"
import script from "./CreateTypeModal.vue?vue&type=script&lang=js&"
export * from "./CreateTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTypeModal.vue?vue&type=style&index=0&id=b244b5fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b244b5fa",
  null
  
)

export default component.exports